export default "__VITE_ASSET__DGjpTi1b__"